var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaintenance = function SvgMaintenance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EAE9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3735 6C15.8933 6 18.7468 8.85347 18.7468 12.3733C18.7468 13.0172 18.6513 13.6388 18.4738 14.2247L25.1202 20.8712C26.2934 22.0444 26.2934 23.9467 25.1202 25.12C23.9469 26.2933 22.0445 26.2933 20.8713 25.12L14.2248 18.4736C13.6389 18.6512 13.0173 18.7467 12.3735 18.7467C8.85359 18.7467 6.00012 15.8932 6.00012 12.3733C6.00012 11.6941 6.10638 11.0396 6.3032 10.4257L9.318 13.4356L12.3062 12.4404L12.4396 12.3069L13.4357 9.32151L10.4174 6.30587C11.0337 6.1073 11.6911 6 12.3735 6Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaintenance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "maintenance.1742e99b6b95fc33fb1933e59798823d.svg";